/* app/js/src/components/common/crop-settings-editor/crop-settings-editor.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.crop-settings table td {
  white-space: nowrap;
  text-align: center;
  width: 60px;
}
.label-generic,
.frame-format-label,
.start-timestamp-ms-field {
  color: #7d8fa1;
  text-transform: uppercase;
  margin-right: 5px;
  font-weight: normal;
  font-size: 0.85em;
}
/*# sourceMappingURL=crop-settings-editor.component.css.map */
